<script lang="ts">
    import { putDBEntry } from "../../api"
    import CollapsibleWrapper from "../components/CollapsibleWrapper.svelte"
    import { onChange } from "../components/formComponents/helper"
    import Input from "../components/formComponents/Input.svelte"
    import Map from "../components/formComponents/Map.svelte"
    import ToggleButton from "../components/ToggleButton.svelte"
    import { isMobile, login, newNotification, rerenderSteps } from "../store"
    import Select from "./inputfields/Select.svelte"
    export let task: Task

    async function updateTask(taskP: Partial<Task>, valueChanged: boolean) {
        if (!valueChanged) return
        await putDBEntry("task", { ...taskP, id: task.id })
            .then(() => {
                newNotification({
                    html: "Auftrag aktualisiert",
                    class: "success",
                })
            })
            .catch(() =>
                newNotification({
                    html: "Fehler beim Aktualisieren des Auftrags",
                    class: "error",
                })
            )
    }
    $: if (!task.generalDetails) task.generalDetails = {}
    $: if (!task.generalDetails.location) task.generalDetails.location = {}
    $: if (task) {
        if (typeof task.meta.contactPerson !== "object") {
            task.meta.contactPerson = {
                id: undefined,
            }
        }
        if (isNaN(selectedTaskType)) selectedTaskType = task?.taskType === "oilSpillRemoval" ? 0 : 1
        if (selectedTaskType == 0) {
            if (task.taskType !== "oilSpillRemoval") {
                task.taskType = "oilSpillRemoval"
                updateTask({ taskType: task.taskType }, true).then(() => ($rerenderSteps += 1))
            }
        } else if (task.taskType !== "towing") {
            task.taskType = "towing"
            updateTask({ taskType: task.taskType }, true).then(() => ($rerenderSteps += 1))
        }
    }

    let selectedTaskType: number
</script>

<form>
    <CollapsibleWrapper
        icon="solar_checklist-outline.svg"
        title="Generelle Einsatzdaten"
        initiallyCollapsed="{$isMobile}"
    >
        <div class="row">
            <div class="col">
                <Input
                    placeholder="Angelegt von (Automatisch Vergeben)"
                    id="createdBy"
                    onChange="{onChange}"
                    onBlur="{(e, valueChanged) => updateTask({ meta: task.meta }, valueChanged)}"
                    disabled="{true}"
                    value="{task.meta.createdBy.name}"
                />
                <Input
                    placeholder="Ausführendes Unternehmen"
                    id="executingCompany"
                    onBlur="{(e, valueChanged) => updateTask({ meta: task.meta }, valueChanged)}"
                    onChange="{onChange}"
                    bind:value="{task.meta.executingCompany}"
                />
                <div style="height: 60px;">
                    <Select
                        field="{{
                            name: 'id',
                            label: 'Kontaktperson',
                            widget: 'select',
                            pathInDb: 'id',
                            options: {
                                endpoint: 'user',
                                params: {
                                    sort: 'username',
                                },
                                mapping: {
                                    id: 'id',
                                    name: 'username',
                                },
                            },
                        }}"
                        bind:value="{task.meta.contactPerson.id}"
                        on:valueChanged="{() => {
                            updateTask(
                                {
                                    meta: task.meta,
                                },
                                true
                            )
                        }}"
                    />
                </div>
                {#if $login?.user?.roles.includes("admin") || ($login?.user?.additionalPermissions || []).includes("createOrders") || ($login?.user?.additionalPermissions || []).includes("assignPeople")}
                    <div style="height: 60px;">
                        <Select
                            field="{{
                                name: 'id',
                                label: 'Zugewiesene Personen',
                                widget: 'select[]',
                                pathInDb: 'id',
                                options: {
                                    endpoint: 'user',
                                    params: {
                                        sort: 'username',
                                        filter:
                                            selectedTaskType == 1
                                                ? {
                                                      $or: [
                                                          {
                                                              roles: 'admin',
                                                          },
                                                          {
                                                              additionalPermissions: 'editTowingOrders',
                                                          },
                                                      ],
                                                  }
                                                : {
                                                      $or: [
                                                          {
                                                              roles: 'admin',
                                                          },
                                                          {
                                                              additionalPermissions: 'editOilSpillOrders',
                                                          },
                                                      ],
                                                  },
                                    },
                                    mapping: {
                                        id: 'id',
                                        name: 'username',
                                    },
                                },
                            }}"
                            bind:value="{task.meta.assignedUsers}"
                            on:valueChanged="{() => {
                                updateTask(
                                    {
                                        meta: task.meta,
                                    },
                                    true
                                )
                            }}"
                        />
                    </div>
                {/if}
                <Input
                    placeholder="Kurzbeschreibung"
                    id="shortDescription"
                    onChange="{onChange}"
                    bind:value="{task.generalDetails.shortDescription}"
                    onBlur="{(_, valueChanged) => updateTask({ generalDetails: task.generalDetails }, valueChanged)}"
                />
                <Input
                    placeholder="Ausführliche Beschreibung"
                    id="detailedDescription"
                    type="textarea"
                    onChange="{onChange}"
                    bind:value="{task.generalDetails.description}"
                    onBlur="{(e, valueChanged) => updateTask({ generalDetails: task.generalDetails }, valueChanged)}"
                />
                {#if selectedTaskType == 1}
                    <div style="height: 60px;">
                        <Select
                            field="{{
                                name: 'damageType',
                                label: 'Schadensart',
                                widget: 'select',
                                pathInDb: 'generalDetails.damageType',
                                options: [
                                    {
                                        value: 'crash',
                                        label: 'Unfall',
                                    },
                                    {
                                        value: 'breakdown',
                                        label: 'Panne',
                                    },
                                ],
                            }}"
                            bind:value="{task.generalDetails.damageType}"
                            on:valueChanged="{() => {
                                updateTask(
                                    {
                                        generalDetails: task.generalDetails,
                                    },
                                    true
                                )
                            }}"
                        />
                    </div>
                {/if}
                <ToggleButton
                    icon1="{selectedTaskType == 0
                        ? 'solar_waterdrops-outline-white.svg'
                        : 'solar_waterdrops-outline.svg'}"
                    icon2="{selectedTaskType == 1 ? 'hugeicons_tow-truck-white.svg' : 'hugeicons_tow-truck.svg'}"
                    title1="{'ÖLWEHREINSATZ'}"
                    title2="{'ABSCHLEPPEINSATZ'}"
                    bind:selected="{selectedTaskType}"
                />
            </div>
            <div class="col">
                {#if task.generalDetails.location}
                    <Input
                        placeholder="Ortsnamen überschreiben"
                        id="nameOverride"
                        onChange="{onChange}"
                        bind:value="{task.generalDetails.location.overriddenName}"
                        onBlur="{(_, valueChanged) =>
                            updateTask({ generalDetails: task.generalDetails }, valueChanged)}"
                    />
                {/if}
                <Map
                    lat="{task?.generalDetails?.location?.latitude}"
                    long="{task?.generalDetails?.location?.langitude}"
                    name="{task?.generalDetails?.location?.name}"
                    onSelectLocation="{(lat, lang, place_name) => {
                        //@ts-ignore
                        task.generalDetails.location = {
                            latitude: lat,
                            langitude: lang,
                            name: place_name,
                        }
                        //@ts-ignore
                        updateTask({ generalDetails: task.generalDetails }, true)
                    }}"
                />
            </div>
        </div>
    </CollapsibleWrapper>
</form>

<style lang="less">
    form {
        width: 100%;
    }
</style>
